jQuery(document).ready(function ($) {
    $(".team_sec").each(function (index) {
        let slide = $(this).find('.team_list__item');
        let slider = $(this).find('.team_sec__inner__list');
        if ($(slide).length > 1) {
            $(slider).slick({
                slidesToShow: 3,
                variableWidth: true,
                infinite: true,
                arrows: true,
                dots: true,
                prevArrow: $(this).find('.prev_arrow'),
                nextArrow: $(this).find('.next_arrow'),
                appendDots: $(this).find('.dots'),
                autoplay: false,
                autoplaySpeed: 4000,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        variableWidth: false,
                        slidesToShow: 1,
                    }
                }
                ]
            });
        }
    });
    
    jQuery(".team_list__item__inner .hover_link").click(function () {
        setTimeout(function () {
            $('.lity').addClass('team_popup_open');
            $('body').addClass('team_popup_active');
        });
    });

    jQuery(document).on('lity:close', function (event, instance) {
        $('.lity').removeClass('team_popup_open');
        $('body').removeClass('team_popup_active');
    });
})

document.addEventListener("DOMContentLoaded", () => {
    const teamSection = document.querySelector(".team_sec");
    if (!teamSection) return;

    const items = Array.from(teamSection.querySelectorAll(".team_list__item__inner"));
    const isMobile = () => window.innerWidth <= 768;

    const setInitial = (item) => {
        const designation = item.querySelector(".designation");
        const longDesignation = item.querySelector(".long_designation");
        const hoverLogo = item.querySelector(".hover_logo");

        if (designation) {
            designation.style.maxHeight = designation.scrollHeight + "px";
            designation.style.opacity = "1";
        }
        if (longDesignation) {
            longDesignation.style.display = "flex";
            longDesignation.style.maxHeight = "0px";
            longDesignation.style.opacity = "0";
        }
        if (hoverLogo) {
            hoverLogo.style.opacity = "0";
        }
        item.classList.remove("active");
    };

    const openItem = (item) => {
        const designation = item.querySelector(".designation");
        const longDesignation = item.querySelector(".long_designation");
        const hoverLogo = item.querySelector(".hover_logo");

        if (designation) {
            designation.style.maxHeight = "0px";
            designation.style.opacity = "0";
        }
        if (longDesignation) {
            longDesignation.style.display = "flex";
            longDesignation.style.maxHeight = longDesignation.scrollHeight + "px";
            longDesignation.style.opacity = "1";
        }
        if (hoverLogo) {
            hoverLogo.style.opacity = "1";
        }
        item.classList.add("active");
    };

    const closeItem = (item) => {
        const designation = item.querySelector(".designation");
        const longDesignation = item.querySelector(".long_designation");
        const hoverLogo = item.querySelector(".hover_logo");

        if (designation) {
            designation.style.maxHeight = designation.scrollHeight + "px";
            designation.style.opacity = "1";
        }
        if (longDesignation) {
            longDesignation.style.maxHeight = "0px";
            longDesignation.style.opacity = "0";
        }
        if (hoverLogo) {
            hoverLogo.style.opacity = "0";
        }
        item.classList.remove("active");
    };

    // Initialize all cards
    items.forEach(setInitial);

    // Event bindings
    items.forEach((item) => {
        const onEnter = () => { if (isMobile()) return; openItem(item); };
        const onLeave = () => { if (isMobile()) return; closeItem(item); };
        const onClick = (e) => {
            if (!isMobile()) return;
            e.preventDefault();
            const wasActive = item.classList.contains("active");
            items.forEach(closeItem);        // close others on mobile
            if (!wasActive) openItem(item);  // toggle current
        };

        item.addEventListener("mouseenter", onEnter);
        item.addEventListener("mouseleave", onLeave);
        item.addEventListener("click", onClick);
    });

    // --- Resize handling with mode change detection ---
    let lastIsMobile = isMobile();

    const resetInteraction = () => {
        items.forEach((item) => {
            setInitial(item);
            item.classList.remove("active");
        });
    };

    window.addEventListener("resize", () => {
        const nowIsMobile = isMobile();
        if (nowIsMobile !== lastIsMobile) {
            resetInteraction(); // reset only when switching mode
            lastIsMobile = nowIsMobile;
        }
    });
});



jQuery(document).on('lity:close', function () {
    jQuery(".team_list__item__inner").removeClass("active");
});